(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-grid"] && !Shopify.designMode) return;
  try {
    
  /* Model picker card: hover-opens on desktop, tap-opens a bottom sheet on
     mobile. Kept tiny — no dependency on Dawn's details-disclosure. */
  class ShowcaseCard extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('[data-showcase-toggle]');
      this.popup = this.querySelector('[data-showcase-popup]');
      this.sheet = this.querySelector('[data-showcase-sheet]');
      this.backdrop = this.querySelector('[data-showcase-backdrop]');
      this.desktop = window.matchMedia('(hover: hover) and (min-width: 1024px)');
      this.open = false;
    }

    connectedCallback() {
      if (!this.toggle) return;
      this.toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setOpen(!this.open);
      });
      this.querySelectorAll('[data-showcase-close], [data-showcase-backdrop]').forEach((el) =>
        el.addEventListener('click', () => this.setOpen(false))
      );
      this.addEventListener('mouseenter', () => {
        if (this.desktop.matches) this.setOpen(true);
      });
      this.addEventListener('mouseleave', () => {
        if (this.desktop.matches) this.setOpen(false);
      });
      document.addEventListener('click', (event) => {
        if (this.open && !this.contains(event.target)) this.setOpen(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.open) this.setOpen(false);
      });
    }

    setOpen(state) {
      if (state === this.open) return;
      this.open = state;
      this.classList.toggle('is-open', state);
      this.toggle.setAttribute('aria-expanded', String(state));
      if (this.popup) this.popup.hidden = !state;
      const onMobile = !this.desktop.matches;
      if (this.sheet) this.sheet.hidden = !(state && onMobile);
      if (this.backdrop) this.backdrop.hidden = !(state && onMobile);
      // Lock the page behind the sheet, the way the Hydrogen picker does.
      if (onMobile) document.body.classList.toggle('showcase-sheet-open', state);
    }
  }

  if (!customElements.get('showcase-card')) customElements.define('showcase-card', ShowcaseCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const sync = () => {
      document.querySelectorAll('[data-footer-accordion]').forEach((details) => {
        details.open = !mobile.matches;
      });
    };
    document.addEventListener('click', (event) => {
      const summary = event.target.closest('[data-footer-accordion] > summary');
      if (summary && !mobile.matches) event.preventDefault();
    });
    sync();
    mobile.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-hero-track]');
      this.slides = [...this.querySelectorAll('.hero-slideshow__slide')];
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      this.prevButton = this.querySelector('[data-hero-prev]');
      this.nextButton = this.querySelector('[data-hero-next]');
      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.timer = null;
      this.pointerStartX = null;
    }

    connectedCallback() {
      if (this.slides.length < 2) return;

      this.prevButton?.addEventListener('click', () => this.go(this.index - 1, true));
      this.nextButton?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1, true);
        if (event.key === 'ArrowRight') this.go(this.index + 1, true);
      });

      this.track.addEventListener('pointerdown', (event) => {
        this.pointerStartX = event.clientX;
        this.pointerId = event.pointerId;
        this.isDragging = false;
      });
      this.track.addEventListener('pointermove', (event) => {
        if (this.pointerStartX === null || event.pointerId !== this.pointerId) return;
        if (this.isDragging || Math.abs(event.clientX - this.pointerStartX) < 10) return;
        this.isDragging = true;
        // Capture only once this is a confirmed drag, not on every
        // pointerdown: capturing unconditionally (even for a plain click)
        // retargets the mouse's click synthesis to the track instead of
        // the slide underneath it, which silently broke a slide's own
        // link on desktop (mouse) even though touch taps kept working —
        // deferring capture until real movement is seen keeps a plain
        // click untouched and only engages capture for an actual swipe,
        // so it can't be reinterpreted as a page-scroll gesture and
        // cancelled partway through.
        this.track.setPointerCapture(this.pointerId);
      });
      this.track.addEventListener('pointerup', (event) => {
        if (this.pointerStartX === null) return;
        const delta = event.clientX - this.pointerStartX;
        const wasDragging = this.isDragging;
        this.pointerStartX = null;
        this.isDragging = false;
        if (!wasDragging || Math.abs(delta) < 40) return;
        // Now that a slide can itself be a link, a real drag ending with
        // the pointer released over that link would otherwise fire it as
        // a click right after this navigates the carousel — suppress the
        // very next click so dragging never doubles as "follow the link".
        this.suppressNextClick = true;
        this.go(this.index + (delta < 0 ? 1 : -1), true);
      });
      this.track.addEventListener('pointercancel', () => {
        this.pointerStartX = null;
        this.isDragging = false;
      });
      this.track.addEventListener(
        'click',
        (event) => {
          if (!this.suppressNextClick) return;
          this.suppressNextClick = false;
          event.preventDefault();
        },
        true,
      );

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      this.startAutoplay();
    }

    go(newIndex, isManual) {
      const total = this.slides.length;
      const previousIndex = this.index;
      const targetIndex = ((newIndex % total) + total) % total;
      if (targetIndex === previousIndex) return;

      this.index = targetIndex;

      const incoming = this.slides[targetIndex];
      const outgoing = this.slides[previousIndex];

      incoming.removeAttribute('inert');
      incoming.classList.add('is-active');

      outgoing.classList.remove('is-active');
      outgoing.setAttribute('inert', '');

      this.track.style.transform = `translateX(-${targetIndex * 100}%)`;

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
      });

      if (isManual) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length < 2) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => this.go(this.index + 1, false), this.speed);
    }

    stopAutoplay() {
      window.clearInterval(this.timer);
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-instagram"] && !Shopify.designMode) return;
  try {
    
  class InstaMarquee extends HTMLElement {
    connectedCallback() {
      this.wrap = this.querySelector('[data-insta-wrap]');
      this.primary = this.querySelector('[data-insta-group="primary"]');
      this.clone = this.querySelector('[data-insta-group="clone"]');
      if (!this.wrap || !this.primary || !this.clone || !this.primary.children.length) return;

      this.baseDuration = parseFloat(this.dataset.duration) || 40;
      this.originals = [...this.primary.children].map((node) => node.cloneNode(true));
      this.copies = 1;
      this.fill();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.wrap.clientWidth === this.lastWidth) return;
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.fill(), 150);
        });
        this.resizeObserver.observe(this.wrap);
      }

      this.addEventListener(
        'touchstart',
        (event) => {
          clearTimeout(this.releaseTimer);
          this.wrap.classList.add('is-paused');
          const item = event.target.closest('.insta-marquee__item');
          this.querySelectorAll('.insta-marquee__item.is-touched').forEach((el) => {
            if (el !== item) el.classList.remove('is-touched');
          });
          if (item) item.classList.add('is-touched');
        },
        { passive: true }
      );

      const release = () => {
        clearTimeout(this.releaseTimer);
        this.releaseTimer = setTimeout(() => {
          this.wrap.classList.remove('is-paused');
          this.querySelectorAll('.insta-marquee__item.is-touched').forEach((el) => el.classList.remove('is-touched'));
        }, 1200);
      };
      this.addEventListener('touchend', release, { passive: true });
      this.addEventListener('touchcancel', release, { passive: true });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.wrap.classList.toggle('is-offscreen', !entry.isIntersecting);
            if (entry.isIntersecting && !this.activated) {
              this.activated = true;
              this.loadImages();
            }
          },
          { rootMargin: '300px 0px' }
        );
        this.observer.observe(this);
      } else {
        this.activated = true;
        this.loadImages();
      }
    }

    // One group must be at least as wide as the viewport, otherwise with few
    // photos on a wide screen the row's end shows before the -50% loop
    // resets. Repeats the photo set as many times as needed (both groups
    // stay identical, so the loop stays seamless) and scales the duration
    // by the same factor so the scroll speed never changes.
    fill() {
      const width = this.wrap.clientWidth;
      if (!width) return;
      this.lastWidth = width;

      const count = this.originals.length;
      const kids = this.primary.children;
      const first = kids[0].getBoundingClientRect();
      const last = kids[count - 1].getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(this.primary).columnGap) || 0;
      const setWidth = last.right - first.left + gap;
      if (setWidth <= 0) return;

      const copies = Math.max(1, Math.ceil(width / setWidth));
      if (copies === this.copies) return;
      this.copies = copies;

      const build = (hideAll) => {
        const nodes = [];
        for (let i = 0; i < copies; i++) {
          this.originals.forEach((node) => {
            const copy = node.cloneNode(true);
            if (hideAll || i > 0) {
              copy.setAttribute('tabindex', '-1');
              copy.setAttribute('aria-hidden', 'true');
            }
            nodes.push(copy);
          });
        }
        return nodes;
      };

      this.primary.replaceChildren(...build(false));
      this.clone.replaceChildren(...build(true));
      this.style.setProperty('--insta-duration', `${this.baseDuration * copies}s`);
      if (this.activated) this.loadImages();
    }

    // Lazy-loaded images inside a horizontally moving row only start
    // downloading as they slide into view, so they flash in blank. Once the
    // section is near the viewport, load every photo in the row up front.
    loadImages() {
      this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      clearTimeout(this.releaseTimer);
      clearTimeout(this.resizeTimer);
    }
  }

  customElements.define('insta-marquee', InstaMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-collection"]) return;
  try {
    
  class CollectionPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.restoreDensity();
      this.initReadMore();

      this.addEventListener('click', (event) => {
        const more = event.target.closest('[data-load-more]');
        if (more) {
          event.preventDefault();
          this.loadMore(more);
          return;
        }
        const density = event.target.closest('[data-density]');
        if (density) this.setDensity(density.dataset.densityScope, density.dataset.density);
      });

      this.observeMore();

      // facets.js swaps #ProductGridContainer's contents on every filter /
      // sort change — re-attach the auto-load watcher to the new button area
      const container = this.querySelector('#ProductGridContainer');
      if (container && 'MutationObserver' in window) {
        this.gridObserver = new MutationObserver(() => {
          this.autoPaused = false;
          this.observeMore();
        });
        this.gridObserver.observe(container, { childList: true });
      }
    }

    disconnectedCallback() {
      if (this.autoObserver) this.autoObserver.disconnect();
      if (this.gridObserver) this.gridObserver.disconnect();
    }

    // Auto-load the next page once the "Load more" area comes within ~700px
    // of the viewport. Pauses after a failed load (manual button only)
    // until a manual load succeeds again.
    observeMore() {
      const wrap = this.querySelector('[data-load-more-wrap]');
      if (wrap === this.observedWrap) return;
      if (this.autoObserver) this.autoObserver.disconnect();
      this.observedWrap = wrap;
      if (!wrap || !wrap.querySelector('[data-load-more]') || !('IntersectionObserver' in window)) return;

      this.autoObserver = new IntersectionObserver(
        (entries) => {
          if (this.autoPaused || !entries.some((entry) => entry.isIntersecting)) return;
          const link = this.querySelector('[data-load-more]');
          if (link) this.loadMore(link);
        },
        { rootMargin: '0px 0px 700px 0px' }
      );
      this.autoObserver.observe(wrap);
    }

    restoreDensity() {
      ['desktop', 'mobile'].forEach((scope) => {
        let saved = null;
        try {
          saved = localStorage.getItem(`bc-collection-cols-${scope}`);
        } catch (e) {}
        if (saved) this.setDensity(scope, saved, false);
        else this.markDensity(scope);
      });
    }

    setDensity(scope, value, persist = true) {
      this.style.setProperty(`--cols-${scope}`, value);
      if (persist) {
        try {
          localStorage.setItem(`bc-collection-cols-${scope}`, value);
        } catch (e) {}
      }
      this.markDensity(scope);
    }

    markDensity(scope) {
      const current = getComputedStyle(this).getPropertyValue(`--cols-${scope}`).trim();
      this.querySelectorAll(`[data-density-scope="${scope}"]`).forEach((btn) => {
        const on = btn.dataset.density === current;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    initReadMore() {
      const text = this.querySelector('[data-readmore-text]');
      const btn = this.querySelector('[data-readmore-toggle]');
      if (!text || !btn) return;
      if (text.scrollHeight > text.clientHeight + 2) btn.hidden = false;
      btn.addEventListener('click', () => {
        const open = text.classList.toggle('is-open');
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    async loadMore(link) {
      if (this.loading) return;
      this.loading = true;

      const grid = this.querySelector('#product-grid');
      const wrap = link.closest('[data-load-more-wrap]');
      const label = link.querySelector('[data-load-more-label]');
      const errorText = wrap && wrap.querySelector('[data-load-more-error]');
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');
      if (errorText) errorText.hidden = true;

      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = doc.querySelectorAll('#product-grid > li');
        if (!items.length) throw new Error('No products in response');

        // a filter/sort change redrew the grid while this was loading —
        // drop this page rather than mixing it into the new results
        if (!grid || !grid.isConnected) return;

        items.forEach((item, index) => {
          item.classList.add('is-new');
          item.style.setProperty('--i', index);
          grid.appendChild(item);
        });

        const nextWrap = doc.querySelector('[data-load-more-wrap]');
        if (wrap && nextWrap) wrap.replaceWith(nextWrap);
        else if (wrap) wrap.remove();

        const status = this.querySelector('[data-load-more-status]');
        if (status) status.textContent = `${items.length} more products loaded`;

        this.autoPaused = false;
        this.observeMore();
      } catch (error) {
        console.error('Collection load more failed:', error);
        this.autoPaused = true;
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
        if (label) label.textContent = 'Try again';
        if (errorText) errorText.hidden = false;
      } finally {
        this.loading = false;
      }
    }
  }

  customElements.define('collection-page', CollectionPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-product"]) return;
  try {
    
  (() => {
    // Sticky add-to-cart bar: shown once the main quantity/add row has
    // scrolled above the viewport; kept in sync with the selected variant.
    const init = () => {
      const bar = document.querySelector('[data-pdp-sticky]');
      const anchor = document.querySelector('[data-pdp-buy]');
      if (!bar || !anchor || bar.dataset.ready) return;
      bar.dataset.ready = 'true';

      const setVisible = (visible) => {
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        const btn = bar.querySelector('[data-pdp-sticky-btn]');
        if (btn) btn.tabIndex = visible ? 0 : -1;
      };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        }).observe(anchor);
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const info = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
          const price = info && info.querySelector('.pdp__price-current');
          const priceSlot = bar.querySelector('[data-pdp-sticky-price]');
          if (price && priceSlot) priceSlot.textContent = price.textContent;

          const btn = bar.querySelector('[data-pdp-sticky-btn]');
          const available = data.variant && data.variant.available;
          if (btn) {
            btn.disabled = !available;
            btn.textContent = available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
          }
        });
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  (() => {
    if (window.__pdpOffers) return;
    window.__pdpOffers = true;

    // Clipboard API first; if it's missing or refuses (insecure context,
    // unfocused document, some in-app browsers), fall back to a hidden
    // textarea + execCommand
    const copyWithTextarea = (text) => {
      const area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
      document.body.appendChild(area);
      area.select();
      const ok = document.execCommand('copy');
      area.remove();
      if (!ok) throw new Error('copy failed');
    };

    const copyText = async (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(text);
          return;
        } catch (error) {
          // fall through to the textarea method
        }
      }
      copyWithTextarea(text);
    };

    // delegated, so offer buttons re-rendered on variant change keep working
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-copy-code]');
      if (!button) return;
      const label = button.querySelector('[data-copy-label]');
      try {
        await copyText(button.dataset.copyCode);
        button.classList.add('is-copied');
        if (label) label.textContent = 'Copied ✓';
      } catch (error) {
        // both methods refused: select the code so it's one long-press away
        const value = button.querySelector('.pdp__offer-code-value');
        if (value) {
          const range = document.createRange();
          range.selectNodeContents(value);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
        if (label) label.textContent = 'Selected';
      }
      clearTimeout(button.copyTimer);
      button.copyTimer = setTimeout(() => {
        button.classList.remove('is-copied');
        if (label) label.textContent = 'Copy';
      }, 1800);
    });

    // "Get it for ₹X" follows the selected variant: take the fresh offers
    // markup from the section HTML product-info.js already fetched
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const id = `Offers-${data.sectionId}`;
        const fresh = data.html && data.html.getElementById(id);
        const current = document.getElementById(id);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pairs-well"] && !Shopify.designMode) return;
  try {
    
  class PairsWell extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-pairs-content]') || this.loading) return;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(this);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async fetchContent(intent) {
      const response = await fetch(`${this.dataset.url}&intent=${intent}`);
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return doc.querySelector('pairs-well [data-pairs-content]');
    }

    async load() {
      this.loading = true;
      const order =
        this.dataset.intent === 'related'
          ? ['related']
          : this.dataset.intent === 'complementary'
            ? ['complementary']
            : ['complementary', 'related'];
      try {
        for (const intent of order) {
          const content = await this.fetchContent(intent);
          if (content) {
            this.innerHTML = content.outerHTML;
            this.classList.add('is-loaded');
            return;
          }
        }
      } catch (error) {
        console.error(error);
      }
      this.closest('.shopify-section')?.classList.add('hidden');
    }
  }

  if (!customElements.get('pairs-well')) customElements.define('pairs-well', PairsWell);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reels"] && !Shopify.designMode) return;
  try {
    
  class ReelShelf extends HTMLElement {
    connectedCallback() {
      this.PREVIEW_SECONDS = 2;
      this.track = this.querySelector('[data-reels-track]');
      this.videos = [...this.querySelectorAll('[data-reel-video]')];

      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const saveData = navigator.connection && navigator.connection.saveData;
      this.autoplayAllowed = !reducedMotion && !saveData;

      this.setupControls();
      this.setupPreviewLoop();
      this.setupLazyPlay();
      this.setupProgress();
      this.setupVisibilityPause();
    }

    setupControls() {
      const activate = (el, handler) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          handler();
        });
        el.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          handler();
        });
      };

      this.querySelectorAll('[data-reel-mute]').forEach((btn) => {
        const video = btn.closest('.reels__card').querySelector('[data-reel-video]');
        activate(btn, () => this.toggleInteract(video));
      });

      // the "Shop Now" pill is the only thing that should navigate away —
      // stop its click from also being read as an "interact with this card"
      this.querySelectorAll('[data-reel-shop-now]').forEach((link) => {
        link.addEventListener('click', (event) => event.stopPropagation());
      });

      // clicking anywhere else on the card (the video itself, its poster,
      // its overlay) counts as interacting with that video too
      this.querySelectorAll('[data-reel-card]').forEach((card) => {
        const video = card.querySelector('[data-reel-video]');
        if (!video) return;
        card.addEventListener('click', () => this.toggleInteract(video));
      });
    }

    // clicking the already-active (unmuted, full-playing) video mutes it
    // back; clicking any other video makes IT the active one instead
    toggleInteract(video) {
      if (video.dataset.full === 'true' && !video.muted) {
        this.muteBack(video);
      } else {
        this.interact(video);
      }
    }

    // makes `activeVideo` the one video with sound, playing in full —
    // every other reel goes back to (or stays on) its muted preview loop
    interact(activeVideo) {
      this.videos.forEach((video) => {
        const isActive = video === activeVideo;
        if (isActive) {
          this.setActive(video);
        } else {
          this.muteBack(video);
        }
      });

      this.activate(activeVideo);
      activeVideo.play().catch(() => {});
    }

    setActive(video) {
      const card = video.closest('.reels__card');
      video.muted = false;
      video.dataset.full = 'true';
      card.classList.add('is-active');

      const btn = card.querySelector('[data-reel-mute]');
      if (btn) {
        btn.classList.remove('is-muted');
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Mute video');
      }
    }

    // mutes a video and drops it back to the short, light preview loop —
    // used both for every non-active reel and for un-toggling the active one
    muteBack(video) {
      const card = video.closest('.reels__card');
      video.muted = true;
      video.dataset.full = 'false';
      if (video.currentTime > this.PREVIEW_SECONDS) {
        video.currentTime = 0;
      }
      card.classList.remove('is-active');

      const btn = card.querySelector('[data-reel-mute]');
      if (btn) {
        btn.classList.add('is-muted');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Unmute video');
      }
    }

    // keeps every reel a short, light preview loop instead of playing the
    // full clip — much less for the browser to buffer with several cards
    // autoplaying at once. Skipped once a video has been interacted with
    // (video.dataset.full === 'true'), letting it play out in full.
    setupPreviewLoop() {
      this.videos.forEach((video) => {
        video.addEventListener('timeupdate', () => {
          if (video.dataset.full === 'true') return;
          if (video.currentTime >= this.PREVIEW_SECONDS) {
            video.currentTime = 0;
          }
        });
      });
    }

    // with autoplay allowed: every card (including the first) only gets its
    // real src + starts playing once it actually scrolls into view, and
    // pauses the moment it scrolls back out — no card is exempt, so nothing
    // keeps decoding/buffering off-screen.
    // with autoplay disallowed (prefers-reduced-motion or Save-Data): skip
    // all of this — cards stay on their poster until tapped.
    setupLazyPlay() {
      if (!this.videos.length || !this.autoplayAllowed) return;

      if (!('IntersectionObserver' in window)) {
        this.videos.forEach((video) => this.activate(video));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              this.activate(video);
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );

      this.videos.forEach((video) => this.observer.observe(video));
    }

    // pauses whatever is currently playing while the browser tab itself is
    // hidden (switched away/minimized) and lets it resume on return —
    // autoplaying video decodes for no one while the tab isn't visible
    setupVisibilityPause() {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.videos.forEach((video) => {
            if (!video.paused) video.pause();
          });
        } else if (this.autoplayAllowed) {
          this.videos.forEach((video) => {
            if (video.src && this.isInView(video)) video.play().catch(() => {});
          });
        }
      });
    }

    isInView(video) {
      const rect = video.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
    }

    activate(video) {
      if (video.src || !video.dataset.src) return;
      video.src = video.dataset.src;
      video.load();
    }

    scrollTrack(direction) {
      if (!this.track) return;
      const card = this.track.querySelector('.reels__slide');
      const step = card ? card.getBoundingClientRect().width + 14 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * direction * 2, behavior: 'smooth' });
    }

    setupProgress() {
      if (!this.track) return;

      this.querySelectorAll('[data-reels-prev]').forEach((btn) => {
        btn.addEventListener('click', () => this.scrollTrack(-1));
      });
      this.querySelectorAll('[data-reels-next]').forEach((btn) => {
        btn.addEventListener('click', () => this.scrollTrack(1));
      });

      let ticking = false;
      this.track.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            this.updateProgress();
            this.updateArrowState();
            ticking = false;
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', () => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => this.updateSliderState(), 150);
      });

      this.updateSliderState();
    }

    updateSliderState() {
      if (!this.track) return;
      const canScroll = this.track.scrollWidth > this.track.clientWidth + 4;
      const progressWrap = this.querySelector('[data-reels-progress]');
      if (progressWrap) progressWrap.hidden = !canScroll;
      this.querySelectorAll('[data-reels-prev], [data-reels-next]').forEach((btn) => {
        btn.hidden = !canScroll;
      });
      this.updateArrowState();
      this.updateProgress();
    }

    // only enables prev/next for the direction there's actually room left
    // to scroll in — at either end, that arrow disables itself
    updateArrowState() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft >= maxScroll - 2;

      this.querySelectorAll('[data-reels-prev]').forEach((btn) => {
        btn.disabled = atStart;
      });
      this.querySelectorAll('[data-reels-next]').forEach((btn) => {
        btn.disabled = atEnd;
      });
    }

    updateProgress() {
      const progressWrap = this.querySelector('[data-reels-progress]');
      const thumb = this.querySelector('[data-reels-progress-thumb]');
      if (!progressWrap || !thumb || progressWrap.hidden || !this.track) return;

      const railWidth = progressWrap.clientWidth;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const ratio = Math.min(this.track.clientWidth / this.track.scrollWidth, 1);
      const thumbWidth = Math.max(railWidth * ratio, 32);
      const maxThumbTravel = Math.max(railWidth - thumbWidth, 0);
      const scrollRatio = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${scrollRatio * maxThumbTravel}px)`;
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('reel-shelf', ReelShelf);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  class CustomTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = [...this.querySelectorAll('[data-tabs-tab]')];
      this.panels = [...this.querySelectorAll('[data-tabs-panel]')];
      this.indicator = this.querySelector('[data-tabs-indicator]');
      this.list = this.querySelector('[data-tabs-list]');
    }

    connectedCallback() {
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
      });

      // one slider per panel, same document order as this.panels/this.tabs
      this.sliders = [...this.querySelectorAll('.tabs-section__slider')];
      this.sliders.forEach((slider) => this.setupSlider(slider));

      window.addEventListener('resize', () => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
          this.moveIndicator(this.activeIndex(), false);
          this.updateSliderState(this.sliders[this.activeIndex()]);
        }, 150);
      });

      // Position immediately, then re-measure once web fonts finish
      // loading — tab widths shift slightly once the real font metrics
      // replace the fallback font's, same as the header nav underline.
      this.moveIndicator(0, false);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.moveIndicator(this.activeIndex(), false));
      }
    }

    activeIndex() {
      return this.tabs.findIndex((t) => t.classList.contains('is-active'));
    }

    select(index) {
      if (this.tabs[index].classList.contains('is-active')) return;

      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      this.moveIndicator(index, true);

      // the panel was just unhidden — wait a frame so layout settles
      // before measuring its slider for overflow/progress state
      const activeSlider = this.sliders[index];
      if (activeSlider) {
        requestAnimationFrame(() => this.updateSliderState(activeSlider));
      }
    }

    moveIndicator(index, animate) {
      const tab = this.tabs[index];
      if (!tab) return;
      this.indicator.style.transition = animate ? '' : 'none';
      this.indicator.style.width = `${tab.offsetWidth}px`;
      this.indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
    }

    scrollTrack(button, direction) {
      const track = button.closest('.tabs-section__slider').querySelector('[data-tabs-track]');
      const card = track.querySelector('.tabs-section__slide');
      const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: step * direction * 2, behavior: 'smooth' });
    }

    setupSlider(slider) {
      const track = slider.querySelector('[data-tabs-track]');
      if (!track) return;

      slider.querySelectorAll('[data-tabs-prev]').forEach((btn) => {
        btn.addEventListener('click', () => this.scrollTrack(btn, -1));
      });
      slider.querySelectorAll('[data-tabs-next]').forEach((btn) => {
        btn.addEventListener('click', () => this.scrollTrack(btn, 1));
      });

      let ticking = false;
      track.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            this.updateProgress(slider, track);
            ticking = false;
          });
        },
        { passive: true }
      );

      this.updateSliderState(slider);
    }

    // hides the prev/next arrows and the progress rail entirely when the
    // track doesn't actually overflow — nothing to scroll, nothing to click
    updateSliderState(slider) {
      if (!slider) return;
      const track = slider.querySelector('[data-tabs-track]');
      if (!track) return;
      const canScroll = track.scrollWidth > track.clientWidth + 4;

      slider.querySelectorAll('[data-tabs-prev], [data-tabs-next]').forEach((btn) => {
        btn.hidden = !canScroll;
      });

      const progressWrap = slider.parentElement.querySelector('[data-tabs-progress]');
      if (progressWrap) progressWrap.hidden = !canScroll;

      this.updateProgress(slider, track);
    }

    updateProgress(slider, track) {
      const progressWrap = slider.parentElement.querySelector('[data-tabs-progress]');
      const thumb = slider.parentElement.querySelector('[data-tabs-progress-thumb]');
      if (!progressWrap || !thumb || progressWrap.hidden) return;

      const railWidth = progressWrap.clientWidth;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const ratio = Math.min(track.clientWidth / track.scrollWidth, 1);
      const thumbWidth = Math.max(railWidth * ratio, 32);
      const maxThumbTravel = Math.max(railWidth - thumbWidth, 0);
      const scrollRatio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${scrollRatio * maxThumbTravel}px)`;
    }
  }

  customElements.define('custom-tabs', CustomTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
